import { render, staticRenderFns } from "./InsolvencyFormFiles.vue?vue&type=template&id=be99f16e&scoped=true&"
import script from "./InsolvencyFormFiles.vue?vue&type=script&lang=js&"
export * from "./InsolvencyFormFiles.vue?vue&type=script&lang=js&"
import style0 from "./InsolvencyFormFiles.vue?vue&type=style&index=0&id=be99f16e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be99f16e",
  null
  
)

export default component.exports